module.exports = {"id":"164491","name":"Dennis Aogo","rating":"74","photo":"./data/images/photos/1/164491.png","club":{"name":"VfB Stuttgart","logo":"./data/images/clubs/VfBStuttgart.png"},"positions":["DG","DLG","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DennisAogo0.json
// module id = 1053
// module chunks = 0